import { render, staticRenderFns } from "./faceLink.vue?vue&type=template&id=b77748e8&scoped=true&"
import script from "./faceLink.vue?vue&type=script&lang=ts&"
export * from "./faceLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77748e8",
  null
  
)

export default component.exports